<template>
  <div>
    <div>
      <div class="d-flex">
        <button
          @click="$modal.show(addManualEmailBounceModalName)"
          class="btn btn-warning"
        >
          Eintrag hinzufügen
        </button>
      </div>
      <table-filter
        :filterComponents="[
          {
            type: 'WhereFilter',
            label: 'User-ID',
            attributes: 'user_id'
          },
          {
            type: 'WhereLikeFilter',
            label: 'E-Mail-Adresse',
            attributes: 'bounced_email_address'
          },
          {
            type: 'WhereLikeFilter',
            label: 'Name',
            attributes: 'profile_name'
          },
          {
            type: 'DateFilter',
            label: 'Datum von',
            attributes: { column: 'created_at', operator: '>=' }
          },
          {
            type: 'DateFilter',
            label: 'Datum bis',
            attributes: { column: 'created_at', operator: '<=' }
          }
        ]"
        v-model="filter"
        @apply-filters="$bus.$emit('refresh-table')"
      ></table-filter>
      <v-table
        url="/api/v1/emailBounce"
        :filter="filter"
        :attributes="[
          {
            attribute: 'user_id',
            name: 'User-ID'
          },
          {
            attribute: 'profile_name',
            name: 'Name'
          },
          {
            attribute: 'bounced_email_address',
            name: 'problematische Email-Adresse'
          },
          {
            attribute: 'bounce_reason',
            name: 'Grund'
          },
          {
            attribute: 'created_at',
            name: 'Zurück gekommen am',
            type: 'DateTimeCell'
          },
          {
            value: 'customerProfile.id',
            name: 'Aktionen',
            type: 'BouncedEmailActionCell'
          }
        ]"
      >
        <div slot="title">Zurückgekommene Emails</div>
      </v-table>
    </div>
    <div class="row">
      <div class="col-6">
        <v-table
          url="/api/v1/emailBounce"
          :filter="[
            {
              name: 'sort',
              mode: 'DESC',
              attribute: 'updated_at'
            },
            {
              name: 'where',
              attributes: { restriction: true }
            }
          ]"
          :attributes="[
            {
              attribute: 'user_id',
              name: 'User-ID'
            },
            {
              attribute: 'updated_at',
              name: 'Geblockt am'
            }
          ]"
        >
          <div slot="title">Gesperrte Mitglieder (Emails)</div>
        </v-table>
      </div>
      <div class="col-6">
        <v-table
          url="/api/v1/emailBounce"
          :filter="[
            {
              name: 'sort',
              mode: 'DESC',
              attribute: 'updated_at'
            },
            {
              name: 'where',
              attributes: { restriction: false }
            }
          ]"
          :attributes="[
            {
              attribute: 'user_id',
              name: 'User-ID'
            },
            {
              attribute: 'updated_at',
              name: 'Entsperrt am'
            }
          ]"
        >
          <div slot="title">Entsperrte Mitglieder (Emails)</div>
        </v-table>
      </div>
    </div>
    <modal :name="addManualEmailBounceModalName">
      <section class="p-3">
        <div slot="title">
          <h2>Email hinzufügen</h2>
        </div>
        <div class="form-group">
          <input
            class="form-control"
            placeholder="Email-Adresse ..."
            v-model="bounceAddress"
          />
        </div>
        <button
          @click="addManualEmailBounce()"
          type="button"
          :disabled="disableModalActions"
          class="btn btn-primary"
        >
          Hinzufügen
        </button>
      </section>
    </modal>
  </div>
</template>

<script lang="babel">
export default {
  data () {
    return {
      bounceAddress: "",
      bounceReason: "manueller Eintrag",
      disableModalActions: false,
      filter: [],
    };
  },
  computed: {
    addManualEmailBounceModalName() {
      return 'add-manual-email-bounce';
    },
  },
  methods: {
    addManualEmailBounce() {
      this.disableModalActions = true;
      this.$http
        .post(
          "/api/v1/emailBounce",
          {
            bounced_email_address: this.bounceAddress,
            bounce_reason: this.bounceReason
          }
        )
        .then(() => {
          this.$notify({
            title: `${this.bounceAddress} wurde hinzugefügt`,
            type: "success"
          });
        })
        .finally(() => {
          this.disableModalActions = false;
          this.bounceAddress = "";
          this.$modal.hide(this.addManualEmailBounceModalName);
          this.$bus.$emit("refresh-table");
        });
    }
  }
};
</script>
